import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import type { ScreenPermission } from '@/api/domains/authorization/permission/permissions.types';
import { logout, loginAsync } from './authSlice';


interface PermissionState {
  permissions: Record<string, ScreenPermission>;
  status: 'idle' | 'loading' | 'succeeded' | 'failed';
  error: string | null;
  lastFetched: number | null;
}

const initialState: PermissionState = {
  permissions: {},
  status: 'idle',
  error: null,
  lastFetched: null,
};

const resetPermissionState = (state: PermissionState): void => {
  state.permissions = {};
  state.status = 'idle';
  state.error = null;
  state.lastFetched = null;
};

const permissionSlice = createSlice({
  name: 'permissions',
  initialState,
  reducers: {
    setPermissions(state, action: PayloadAction<Record<string, ScreenPermission>>) {
      state.permissions = action.payload;
      state.status = 'succeeded';
      state.lastFetched = Date.now();
      state.error = null;
    },
    clearPermissions(state) {
      resetPermissionState(state);
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(logout, (state) => {
        resetPermissionState(state);
      })
      .addCase(loginAsync.fulfilled, (state) => {
        resetPermissionState(state);
      });
  },
});

export const { setPermissions, clearPermissions } = permissionSlice.actions;
export default permissionSlice.reducer;
